import React from 'react';
import { StatusEmployee } from './type';

import { getStatusColor, getStatus } from './formatter';
import { Container, Circle, Text } from './Status.styles';

export const Status = ({ status }: StatusEmployee): JSX.Element => {
	const stringStatus = getStatus(status);

	return (
		<Container>
			<Circle backgroundColor={getStatusColor(status)} />
			<Text>{stringStatus}</Text>
		</Container>
	);
};
